<template>
  <v-dialog v-model="dialog_ref" max-width="768">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="ma-auto red lighten-2 white--text"
        v-bind="attrs"
        v-on="on"
        block
        :disabled="invalid"
        @click="emitOpen"
      >
        <v-icon>mdi-email</v-icon>&nbsp;CORREO
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="text-h5 red lighten-2 white--text">
        Enviar por correo&nbsp;<v-icon class="white--text pt-1"
          >mdi-email</v-icon
        >
        <v-spacer></v-spacer>
        <v-btn icon outlined class="white--text" @click="emitClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-form
          id="email-form"
          ref="form"
          v-model="valid"
          @submit.prevent="sendMsg"
        >
          <v-combobox
            :rules="[required, atLeastOne]"
            :delimiters="[',', ';', ' ']"
            v-model="select"
            label="Enviar a"
            hint="Puede agregar múltiples correos"
            persistent-hint
            multiple
            small-chips
            deletable-chips
            counter
            append-icon=""
          ></v-combobox>
          <v-text-field
            label="Asunto"
            v-model="subject"
            :rules="[required]"
          ></v-text-field>
          <v-textarea
            label="Mensaje"
            v-model="message"
            :rules="[required]"
          ></v-textarea>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="emitClose">
          <v-icon>mdi-close</v-icon>&nbsp;Cerrar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          type="submit"
          form="email-form"
          color="primary"
          :disabled="!valid"
        >
          <v-icon>mdi-send</v-icon>&nbsp;Enviar
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
    <v-overlay :value="overlay" z-index="6">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { required, emailRegex } from "@/helpers/formHelpers";
import { fileByMail } from "../../services/apiService";
export default {
  props: {
    dialog_ref: Boolean,
  },
  data() {
    return {
      overlay: false,
      valid: false,
      subject: "Cotización",
      message: null,
      select: [],
      required,
      emailRegex,
      atLeastOne: (v) => !!v.length != 0 || "Este campo es requerido",
    };
  },
  methods: {
    updateMail(event) {
      this.$store.commit("setEmail", event);
    },
    emitOpen() {
      this.setMessage();
      this.select = this.mail ? [this.mail] : [];
      this.$emit("onOpen");
    },
    emitClose() {
      this.$emit("onClose");
    },
    setMessage() {
      this.message = `Buen día estimado ${
        this.clientName
      },\n\nAdjunto en el presente correo la cotización solicitada, quedamos atentamente a sus órdenes para cualquier duda y/o aclaración al respecto.\n\nReciba un cordial saludo.\n- ${
        JSON.parse(sessionStorage.getItem("user"))["nombre_completo"]
      }`;
    },
    async sendMsg() {
      for (const e of this.select) {
        const valid = emailRegex.test(e);
        if (valid == false) {
          this.$toasted.show(`${e} no es un correo válido`, {
            type: "warning",
          });
          return;
        }
      }
      this.overlay = true;

      const body = {
        sender: JSON.parse(sessionStorage.getItem("user"))["email"],
        message: this.message,
        emails: this.select,
        subject: this.subject,
        quotation: this.$store.state.current,
      };

      const { data, error } = await fileByMail(body).catch((err) => {
        if (err) {
          this.$toasted.show("Ha ocurrido un error. Intente de nuevo", {
            type: "error",
          });
          this.overlay = false;
          return;
        }
      });

      if (error != null) {
        this.$toasted.show(data?.message, {
          type: "error",
        });
        this.overlay = false;
        return;
      }

      this.$toasted.show(data?.message, {
        type: "success",
      });
      this.overlay = false;
      this.emitClose();
    },
  },
  computed: {
    mail() {
      return this.$store.state.client.email;
    },
    clientName() {
      return this.$store.state.client.name ?? "cliente";
    },
    invalid() {
      return this.$store.state.invalid;
    },
  },
};
</script>